import './alteration-card-list.scss'

import { defineComponent, PropType } from 'vue';

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import AlterationCard, { ALTERATION_CARD_ALTERATION_UPDATED, ALTERATION_CARD_DELETE_ALTERATION, AlterationWithThesaurusTerm, MainAlterationCardField } from "../alteration-card";

export default defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sAlterationCard: AlterationCard,
    },
    props: {
        alterations: {
            type: Array as PropType<(AlterationWithThesaurusTerm & { index?: number })[]>
        },
        mainField: {},
        readOnly: {
            type: Boolean,
        },
        existingTitles: {
            type: Array as PropType<String[]>,
            default:() => []
        },
    },
    template: require('./alteration-card-list.html'),
    data() {
        return {
            ALTERATION_CARD_DELETE_ALTERATION: ALTERATION_CARD_DELETE_ALTERATION,
            ALTERATION_CARD_ALTERATION_UPDATED: ALTERATION_CARD_ALTERATION_UPDATED,
        }
    },
    methods: {
        getAlterationIndex(alteration: AlterationWithThesaurusTerm & { index?: number }, index) {
            return alteration.index ? alteration.index : index
        },
    },
})
